import api from "@/utils/api.util";
export class UserService {
  static RESOURCE = "/users/";

  static all(params = {}) {
    return api.get(this.RESOURCE, { params });
  }

  static find(id, params = {}) {
    return api.get(this.RESOURCE + id, params);
  }

  static create(payload = {}) {
  	return api.post(this.RESOURCE, payload);
  }

  static update(id, payload = {}) {
    return api.put(this.RESOURCE + `${id}`, payload);
  }

  static switchContract(user_id, contract_id) {
    return api.put(this.RESOURCE + `${user_id}/contracts/${contract_id}/switch`);
  }

  static syncContracts(user_id, contract_ids = []) {
    return api.put(this.RESOURCE + `${user_id}/contracts/`, { contract_ids });
  }
}
